import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import PackageTable from "../../components/PackageSizes/PackageTable";
import AddPackage from "../../components/PackageSizes/AddPackage";


const AddPackagePage = () => {
    return (
        <>
            {/* MasterLayout */}
            <MasterLayout>

                <Breadcrumb title="Add Package" subtitle={"Packages Sizes"} subUrl={"package-sizes"} />
                {/* <AddEmailTemp /> */}
                <AddPackage/>


            </MasterLayout>
        </>
    );
};

export default AddPackagePage;
